import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { GetAllNumbersWithPaginationDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { PrivateNumbersService } from '../../../core/api/services/private-numbers.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';

@Component({
  selector: 'app-system-numbers',
  templateUrl: './system-numbers.component.html',
  imports: [BaseIndexModule],
})
export class SystemNumbersComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.systemNumbers;
  modelWithPagination$: Observable<GetAllNumbersWithPaginationDto>;
  items$: Observable<Array<GetAllNumbersWithPaginationDto>>;

  NumberTypeEnumValues: GetEnumValuesDto[] = [];
  SmsCpEnumValues: GetEnumValuesDto[] = [];

  // Binding API methods
  protected currentService = inject(PrivateNumbersService);
  paginationApiMethodName: string =
    this.currentService.privateNumbersGetAllNumberListWithPagination.name;
  createGetApiMethodName: string =
    this.currentService.privateNumbersCreateGet.name;

  //#endregion

  constructor() {
    super();
  }
  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = true;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('NumberType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.NumberTypeEnumValues = values));
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: `${this.tableVocabs}number`,
        name: 'number',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}numberType`,
        name: 'numberType',
        hasSearch: true,
        type: 'enum',
        enumName: 'NumberType',
      },
      {
        title: 'common.smsCp',
        name: 'smsCp',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsCp',
      },
      {
        title: `${this.tableVocabs}organizationName`,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: 'common.sendToBlackList',
        name: 'sendToBlackList',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  setDefaultTableSort() {
    try {
      this.sortObject.push({ columnName: 'number', sort: 1 });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
